/**
 * @generated SignedSource<<9430460893da95bffba327e5254fbc04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FireHydrantIntegration_integration$data = {
  readonly credentials: any;
  readonly id: any;
  readonly integrationType: IntegrationType;
  readonly name: string;
  readonly " $fragmentType": "FireHydrantIntegration_integration";
};
export type FireHydrantIntegration_integration$key = {
  readonly " $data"?: FireHydrantIntegration_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"FireHydrantIntegration_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FireHydrantIntegration_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "integrationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credentials",
      "storageKey": null
    }
  ],
  "type": "GraphQLIntegration",
  "abstractKey": null
};

(node as any).hash = "d79cc5b1e08d285c68f8686cf3f7135a";

export default node;
